import './index.scss';

import React from 'react';
import ReactDOM from 'react-dom';

import { AppWithContext } from './app/App.component';

ReactDOM.render(
  <React.StrictMode>
    <AppWithContext />
  </React.StrictMode>,
  document.getElementById('eabd-d2-root')
);
